import {
  AlignmentType,
  Document,
  HorizontalPositionRelativeFrom,
  ImageRun,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
} from 'docx'
import watermarkLogo from '@/assets/watermark.png'
import BaseText from '../BaseText'
import BaseFooter from '../BaseFooter'

const LETTER_PAGE_SIZE = {
  width: 12240,
  height: 15840,
  orientation: 'portrait',
}

class ResguardoArmamentoMuniciones {
  constructor({ nombre = '', cuip = '', fecha = '', armas = [] } = {}) {
    this.nombre = nombre
    this.cuip = cuip
    this.fecha = fecha
    this.armas = armas
  }
  get LineaEnBlanco() {
    return new Paragraph({
      children: [],
      spacing: { after: 800 },
    })
  }

  get Titulo() {
    return new Paragraph({
      children: [
        new BaseText('RESGUARDO DE ARMAMENTO Y MUNICIONES', {
          bold: true,
        }).value,
      ],
      alignment: 'center',
    })
  }

  get Resguardo() {
    const NUMERO_RESGUARDO = 'No. 1'

    return new Paragraph({
      children: [new BaseText('Resguardo: ', { size: 19 }, { bold: true }).value, new BaseText(NUMERO_RESGUARDO).value],
      alignment: 'end',
    })
  }

  get Asunto() {
    const ASUNTO = 'Secretaria de Seguridad Ciudadana'
    return new Paragraph({
      children: [
        new BaseText('ASUNTO: ', { size: 19 }, { bold: true }).value,
        new BaseText(ASUNTO, { size: 19 }).value,
      ],
      alignment: 'end',
    })
  }

  get Fecha() {
    const [year, month, day] = this.fecha ? this.fecha.split('-') : ['2025', '01', '**']
    const meses = [
      '',
      'ENERO',
      'FEBRERO',
      'MARZO',
      'ABRIL',
      'MAYO',
      'JUNIO',
      'JULIO',
      'AGOSTO',
      'SEPTIEMBRE',
      'OCTUBRE',
      'NOVIEMBRE',
      'DICIEMBRE',
    ]
    return new Paragraph({
      children: [
        new BaseText('TLAXCALA, TLAX.,A ', { size: 19 }, { bold: false }).value,
        new BaseText(day || '**', { size: 19 }).value,
        new BaseText(' DE ', { size: 19 }, { bold: false }).value,
        new BaseText(meses[parseInt(month, 10)] || '******', { size: 19 }).value,
        new BaseText(' DEL ' + (year || '2025'), { size: 19 }, { bold: false }).value,
      ],
      alignment: 'end',
    })
  }

  get Cuerpo() {
    return [
      new Paragraph({
        children: [
          new BaseText(
            'Manifiesto que el armamento y municiones, propiedad del Gobierno del Estado, amparado en la Licencia Oficial Colectiva No. 120, expedida a nombre de la Secretaría de Seguridad Ciudadana por la Secretaría de la Defensa Nacional, según oficio No. S.L./00978 de fecha 27 de enero de 2025, con vigencia del 14 de febrero de 2025 al 13 de febrero de 2027, el cual se entrega para el desempeño de mis funciones de seguridad y vigilancia, obligándome a tener en buen estado el armamento, municiones y accesorios, haciendo uso racional de ellos solo en el desempeño del servicio, cumpliendo oportunamente las obligaciones que me impone la Ley Federal de Armas de Fuego y Control de Explosivos, su Reglamento, la Licencia Oficial Colectiva No. 120 y, en lo particular, la prevista en los artículos 18 fracción VII, 19 fracción XXI y 52 fracción V de la Ley de Seguridad Pública y Ciudadana del Estado de Tlaxcala y demás disposiciones aplicables; asimismo, en caso de extravío, me comprometo a notificar con parte informativo dirigido al Titular de la Secretaría de Seguridad Ciudadana con copia de conocimiento al Departamento de Armamento y Municiones para los efectos correspondientes.',
            { size: 20 }
          ).value,
          new BaseText(
            'En caso de extravío o robo del arma, me comprometo a informar inmediatamente a la Secretaría de Seguridad Ciudadana y denunciar los hechos ante la Representación Social correspondiente, y a pagar el valor actualizado de la misma, más los gastos administrativos que se generen en caso de extraviarla y no justificar eficientemente su pérdida, para lo cual acepto las condiciones de pago que la Secretaría de Finanzas del Gobierno del Estado considere convenientes, sin perjuicio de que se apliquen las sanciones que procedan.',
            { size: 20 }
          ).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
      this.LineaEnBlanco,
      new Paragraph({
        children: [new BaseText('DATOS LABORALES DE SU PORTADOR', { size: 20 }).value],
      }),
      new Paragraph({ children: [], spacing: { after: 300 } }),
      new Paragraph({
        children: [
          new BaseText('NOMBRE: ', { size: 22 }).value,
          new BaseText(this.nombre, { size: 22 }, { underline: true }).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
      new Paragraph({
        children: [
          new BaseText('CUIP: ', { size: 22 }).value,
          new BaseText(this.cuip, { size: 22 }, { underline: true }).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
      new Paragraph({
        children: [
          new BaseText('ADSCIPCIÓN: ', { size: 22 }).value,
          new BaseText('SECRETARÍA DE SEGURIDAD CIUDADANA', { size: 22 }, { underline: true }).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
    ]
  }
  get TextoTablaArmamento() {
    return new Paragraph({
      children: [new BaseText('DESCRIPCIÓN DEL ARMAMENTO:', { size: 20 }, { bold: true }).value],
      alignment: AlignmentType.LEFT,
      spacing: { after: 400 },
    })
  }

  get Firmas() {
    return new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [new BaseText('ENTREGUE', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({ children: [], spacing: { after: 300 } }),
                new Paragraph({
                  children: [new BaseText('GARCIA GUZMÁN FLOR', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [new BaseText('ENCARGADA DEL DEPARTAMENTO DE', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [new BaseText(' ARMAMENTO Y MUNICIONES DE LA S.S.C.', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: 'center',
            }),
            new TableCell({
              children: [],
              verticalAlign: 'center',
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new BaseText('RECIBÍ', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({ children: [], spacing: { after: 300 } }),
                new Paragraph({
                  children: [new BaseText('FIRMA DE ACEPTACIÓN Y RECEPCIÓN', { size: 20 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new BaseText('No. Tel.: ', { size: 20 }).value,
                    new BaseText('*********************', { size: 20 }, { underline: true }).value,
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: 'center',
            }),
          ],
        }),
      ],
      width: {
        size: 100,
        type: 'pct',
      },
      borders: {
        top: { style: 'none', size: 0, color: 'FFFFFF' },
        bottom: { style: 'none', size: 0, color: 'FFFFFF' },
        left: { style: 'none', size: 0, color: 'FFFFFF' },
        right: { style: 'none', size: 0, color: 'FFFFFF' },
        insideHorizontal: { style: 'none', size: 0, color: 'FFFFFF' },
        insideVertical: { style: 'none', size: 0, color: 'FFFFFF' },
      },
    })
  }

  async MarcaAgua() {
    const watermarkBuffer = await fetch(watermarkLogo)
      .then((r) => r.blob())
      .then((b) => b.arrayBuffer())

    return new Paragraph({
      children: [
        new ImageRun({
          data: watermarkBuffer,
          type: 'png',
          transformation: {
            width: 300,
            height: 600,
          },
          floating: {
            horizontalPosition: {
              align: 'left',
            },
            verticalPosition: {
              align: 'center',
            },
            behindDocument: true,
          },
          transparency: 0.18,
        }),
      ],
    })
  }

  async generate() {
    try {
      const marcaAgua = await this.MarcaAgua()
      const footer = await BaseFooter.generate()

      const tablasArmas = this.armas.flatMap((arma, index) => [
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [new BaseText(`Arma ${index + 1}`, { bold: true, size: 18 }).value],
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  columnSpan: 11,
                }),
              ],
            }),
            new TableRow({
              children: [
                new TableCell({ children: [new Paragraph({ text: 'NÚM' })] }),
                new TableCell({ children: [new Paragraph({ text: 'ETIQUETA' })] }),
                new TableCell({ children: [new Paragraph({ text: 'TIPO' })] }),
                new TableCell({ children: [new Paragraph({ text: 'MATRICULA' })] }),
                new TableCell({ children: [new Paragraph({ text: 'CAL' })] }),
                new TableCell({ children: [new Paragraph({ text: 'MARCA' })] }),
                new TableCell({ children: [new Paragraph({ text: 'MODELO' })] }),
                new TableCell({ children: [new Paragraph({ text: 'FOLIO C' })] }),
                new TableCell({ children: [new Paragraph({ text: 'FOLIO D' })] }),
                new TableCell({ children: [new Paragraph({ text: 'CARTS' })] }),
                new TableCell({ children: [new Paragraph({ text: 'CARGS' })] }),
              ],
            }),
            new TableRow({
              children: [
                new TableCell({ children: [new Paragraph({ text: arma.noEconomico || '' })] }),
                new TableCell({ children: [new Paragraph({ text: 'S/D' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.CatClase?.CatTipo?.title || 'S/D' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.matricula || '' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.CatCalibre?.title || '' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.CatModelo?.CatMarca?.title || '' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.CatModelo?.modelo || '' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.folioC || '' })] }),
                new TableCell({ children: [new Paragraph({ text: arma.folioD || '' })] }),
                new TableCell({ children: [new Paragraph({ text: 'S/D' })] }),
                new TableCell({
                  children: [new Paragraph({ text: arma.cantidadCargadores?.toString() ?? '0' })],
                }),
              ],
            }),
          ],
        }),
        this.LineaEnBlanco,
      ])

      const document = new Document({
        sections: [
          {
            properties: { page: { size: { ...LETTER_PAGE_SIZE } } },
            children: [
              marcaAgua,
              this.Titulo,
              this.Resguardo,
              this.Asunto,
              this.Fecha,
              this.LineaEnBlanco,
              ...this.Cuerpo,
              this.LineaEnBlanco,
              this.TextoTablaArmamento,
              ...tablasArmas,
              this.LineaEnBlanco,
              this.Firmas,
            ],

            footers: { default: footer },
          },
        ],
      })

      return document
    } catch (error) {
      console.error('Error generating ResguardoArmamentoMuniciones document:', error)
      throw error
    }
  }
}

export default ResguardoArmamentoMuniciones
